import api from '../../config/api';
import http from '../http';
import { DrugDiseaseResponse } from '../../interfaces/api/drugs';

const diseases = {
  /**
   * Fetches all sections of content for a single drug or disease.
   * @param id - The ID of the disease.
   * @returns Promise<DrugItemDetailsType[] | null>
   */
  getDiseasesDetails: async (id: number): Promise<DrugDiseaseResponse> => {
    return http.get(`${api.diseases}/${id}`);
  },
};

export default diseases; 